<template>
  <thead>
    <table-tr v-for="row in rows" :key="row" :data="row" />
  </thead>
</template>

<script>
import TableTr from './tr'
export default {
  name: 'TableThead',
  components: { TableTr },
  props: {
    rows: {
      default: () => [],
      required: false,
      type: Array
    }
  }
}
</script>
